class ProductAccessories extends HTMLElement {
  constructor() {
    super();

    this.productEl = this.closest('.js-product');

    console.log('this.productEl', this.productEl);

    this.productForm = this.productEl.querySelector('product-form');
    this.accessoryCheckboxes = this.querySelectorAll('.product-accessories__item-checkbox');
    this.accessoryQuantities = this.querySelectorAll('.product-accessories__item-quantity');

    this.activeAccessories = [];
    
    this.accessoryCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
    });

    this.accessoryQuantities.forEach(quantity => {
      quantity.addEventListener('change', this.handleQuantityChange.bind(this));
    });
  }

  handleCheckboxChange(event) {
    let bundleId = this.getAttribute('data-bundle-id'),
    quantity = event.target.nextElementSibling.querySelector('.product-accessories__item-quantity')?.value;
    if(event.target.checked) {
      this.activeAccessories.push({
          id: event.target.value,
          quantity: quantity ? Number(quantity) : 1,
          properties: {
              _bundle_id: bundleId,
              productTitle: this.dataset?.title
          },
      });
    } else {
      this.activeAccessories = this.activeAccessories.filter(accessory => accessory.id !== event.target.value);
    }

    this.productForm.setAttribute('data-accessories', JSON.stringify(this.activeAccessories));
  }

  handleQuantityChange(event) {
    let quantity = Number(event.target.value);
    if(quantity > event.target.max) {
      event.target.value = event.target.max;
      quantity = event.target.max;
    }
    if(quantity < event.target.min) {
      event.target.value = event.target.min;
      quantity = event.target.min;
    }
    
    let accessoryId = event.target.closest('.product-accessories__item').querySelector('.product-accessories__item-checkbox').value;
    this.activeAccessories = this.activeAccessories.map(accessory => accessory.id === accessoryId ? { ...accessory, quantity: Number(event.target.value) } : accessory);
    this.productForm.setAttribute('data-accessories', JSON.stringify(this.activeAccessories));
  }
}

customElements.define('product-accessories', ProductAccessories);

class SimpleGridSlider extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.container = this.querySelector('.simple-slider__container');
    this.grid = this.querySelector('.simple-slider__grid');
    this.prevBtn = this.querySelector('.simple-slider__btn--prev');
    this.nextBtn = this.querySelector('.simple-slider__btn--next');
    
    if (!this.container || !this.grid) return;
    
    this.currentSlide = 0;
    this.isAnimating = false;
    
    this.setupSlider();
    this.bindEvents();
    this.updateButtonStates();
  }

  setupSlider() {
    const containerWidth = this.container.clientWidth;
    const gridWidth = this.container.scrollWidth;
    
    const maxScrollLeft = gridWidth - containerWidth;
    
    if (maxScrollLeft <= 0) {
      this.totalSlides = 1;
    } else {
      this.totalSlides = Math.ceil(maxScrollLeft / containerWidth) + 1;
    }
    
    this.totalSlides = Math.max(1, this.totalSlides);
  }

  bindEvents() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.prevSlide());
    }
    
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.nextSlide());
    }
    
    // Update slider on resize
    window.addEventListener('resize', this.debounce(() => {
      this.setupSlider();
      this.updateButtonStates();
    }, 300));
    
    this.container.addEventListener('scroll', this.debounce(() => {
      this.updateCurrentSlideFromScroll();
      this.updateButtonStates();
    }, 100));
  }

  nextSlide() {
    if (this.isAnimating) return;
    
    const containerWidth = this.container.clientWidth;
    const currentScrollLeft = this.container.scrollLeft;
    const maxScrollLeft = this.container.scrollWidth - containerWidth;
    
    if (currentScrollLeft >= maxScrollLeft - 1) return;
    
    this.currentSlide++;
    this.scrollToSlide(this.currentSlide);
  }

  prevSlide() {
    if (this.isAnimating || this.currentSlide <= 0) return;
    
    this.currentSlide--;
    this.scrollToSlide(this.currentSlide);
  }

  scrollToSlide(slideIndex) {
    if (this.isAnimating) return;
    
    this.isAnimating = true;
    const containerWidth = this.container.clientWidth;
    const scrollLeft = slideIndex * containerWidth;
    
    this.container.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
    
    setTimeout(() => {
      this.isAnimating = false;
      this.updateButtonStates();
    }, 400);
  }

  updateCurrentSlideFromScroll() {
    const containerWidth = this.container.clientWidth;
    const scrollLeft = this.container.scrollLeft;
    this.currentSlide = Math.round(scrollLeft / containerWidth);
  }

  updateButtonStates() {
    if (!this.prevBtn || !this.nextBtn) return;
    
    const containerWidth = this.container.clientWidth;
    const scrollLeft = this.container.scrollLeft;
    const scrollWidth = this.container.scrollWidth;
    const maxScrollLeft = scrollWidth - containerWidth;
    
    const isAtStart = scrollLeft <= 1;
    this.prevBtn.disabled = isAtStart;
    this.prevBtn.classList.toggle('simple-slider__btn--disabled', isAtStart);
    
    const isAtEnd = scrollLeft >= maxScrollLeft - 1;
    this.nextBtn.disabled = isAtEnd;
    this.nextBtn.classList.toggle('simple-slider__btn--disabled', isAtEnd);
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

customElements.define('simple-grid-slider', SimpleGridSlider);